import { ReactNode } from 'react'

export const NavBadge = ({ children }: { children: ReactNode }) => <span className="shell__nav-soon">{children}</span>
